export default __webpack_public_path__ + "static/media/leftarrow_black.902cce85.svg";